// 国际化
import { createI18n } from 'vue-i18n';
import config from '@/config/config';
import zh from './zh-CN';
import en from './en-US';
// 如果本地缓存记录了语言环境，则使用本地缓存
const isLocale = localStorage.getItem(config.prefix + 'locale') || (navigator.language === 'en' ? 'en-US' : 'zh-CN');
// console.log(99999, isLocale, localStorage.getItem(config.prefix + 'locale'), navigator.language)
export default createI18n({
  locale: isLocale,
  legacy: false, // 修复组件引入i18n时vite脚手架报错的问题
  globalInjection: true, // 全局注册 $t
  messages: {
    'en-US': en,
    'zh-CN': zh
  }
});

export const langs = [
  { label: '中文', value: 'zh-CN' },
  { label: 'English', value: 'en-US' }
];
